import { useEffect, useState } from "react";

/**
 * Liefert einen dezenten Parallax-Versatz in Pixeln beim Scrollen.
 * Respektiert "Bewegung reduzieren" und nutzt requestAnimationFrame.
 */
export const useParallax = (factor = 0.25, max = 120) => {
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

    let frame = 0;
    const onScroll = () => {
      if (frame) return;
      frame = window.requestAnimationFrame(() => {
        frame = 0;
        setOffset(Math.min(window.scrollY * factor, max));
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => {
      window.removeEventListener("scroll", onScroll);
      if (frame) window.cancelAnimationFrame(frame);
    };
  }, [factor, max]);

  return offset;
};
